export const UPLOAD_FILE_ERROR_EVENT = 'iuspro:upload-file-error'

export type UploadFileErrorItem = {
	fileName: string
	fileSize: number
	limitSize: number
	message: string
}

export type UploadFileErrorEventDetail = {
	errors: UploadFileErrorItem[]
}

export function formatUploadFileSize(bytes: number) {
	if (!Number.isFinite(bytes) || bytes <= 0) return '0 MB'

	const megabytes = bytes / (1024 * 1024)
	if (megabytes >= 1) {
		return `${new Intl.NumberFormat('es-CR', {
			maximumFractionDigits: megabytes >= 10 ? 0 : 1,
		}).format(megabytes)} MB`
	}

	return `${new Intl.NumberFormat('es-CR', {
		maximumFractionDigits: 0,
	}).format(bytes / 1024)} KB`
}

export function dispatchUploadFileErrors(errors: UploadFileErrorItem[]) {
	if (errors.length === 0 || typeof window === 'undefined') return

	window.dispatchEvent(
		new CustomEvent<UploadFileErrorEventDetail>(UPLOAD_FILE_ERROR_EVENT, {
			detail: { errors },
		}),
	)
}
